// Ledger workspace — unified financial surface.
//
// Three sub-tabs: Procurement / Billing Summaries / Receipts.
// Presentation-only (no new data tables); reads from existing app state
// (items, proposals, invoices, payment_allocations, vendor_payments,
// purchase_orders, receipts, billing_summaries) and shows a unified
// financial roll-up. Receipts is still a stub.
//
// Owner + bookkeeper only (financeOnly gate in ProcurementApp's nav).

import React, { useState } from 'react';
import { useAppContext } from '../AppContext';
import LedgerProcurement from './LedgerProcurement';
import LedgerBillingSummaries from './LedgerBillingSummaries';

function StubPanel(p) {
  return (
    <div style={{
      padding: 40, textAlign: 'center', color: '#888',
      border: '0.5px dashed #D8D7D2', borderRadius: 6, background: '#FAFAF8',
    }}>
      <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 6 }}>{p.title}</div>
      <div style={{ fontSize: 11 }}>{p.note}</div>
    </div>
  );
}

export default function Ledger(p) {
  var ctx = useAppContext();
  var firmSettings = p.firmSettings || ctx.firmSettings || {};

  var ts = useState('procurement'); var sub = ts[0]; var setSub = ts[1];

  var TabBtn = function(props) {
    var active = props.active;
    return (
      <button onClick={props.onClick} style={{
        padding: '8px 14px', fontSize: 12, fontWeight: active ? 600 : 400,
        background: 'none', border: 'none',
        borderBottom: active ? '2px solid #111' : '2px solid transparent',
        color: active ? '#111' : '#888', cursor: 'pointer', fontFamily: 'inherit',
      }}>{props.children}</button>
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: -.3 }}>Ledger</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 4, borderBottom: '0.5px solid #E0E0DC', marginBottom: 14 }}>
        <TabBtn active={sub === 'procurement'} onClick={function() { setSub('procurement'); }}>Procurement</TabBtn>
        <TabBtn active={sub === 'billing'}     onClick={function() { setSub('billing'); }}>Billing Summaries</TabBtn>
        <TabBtn active={sub === 'receipts'}    onClick={function() { setSub('receipts'); }}>Receipts</TabBtn>
      </div>

      {sub === 'procurement' && <LedgerProcurement firmSettings={firmSettings} />}
      {sub === 'billing'     && <LedgerBillingSummaries firmSettings={firmSettings} />}
      {sub === 'receipts'    && <StubPanel title="Receipts" note="Unified receipt ledger: vendor / reimbursable / Office with paid/billed status. Shipping in commit 4." />}
    </div>
  );
}
